export const londons = [
  {
    ll_id: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    ru_id: "465873",
    verified: "no",
    city: "london",
    neigbourhood: "southwark",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "3",
    price: "5291",
    price_vs_Market: "-2139",
    available_from: "12/2/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/465873",
  },
  {
    ll_id: "831383f9-f15d-421f-b404-c45372fd0707",
    ll_name: "Let Club ltd",
    ru_id: "266723",
    verified: "yes",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "2791.666667",
    price_vs_Market: "-2048.333333",
    available_from: "12/4/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/london/for-rent:apartments/266723",
  },
  {
    ll_id: "ddbc053c-262c-4cb5-a444-a0c58389fe35",
    ll_name: "Hello Guest",
    ru_id: "428590",
    verified: "no",
    city: "london",
    neigbourhood: "camden",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "2100",
    price_vs_Market: "-1900",
    available_from: "12/15/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/428590",
  },
  {
    ll_id: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    ru_id: "601914",
    verified: "no",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "2976",
    price_vs_Market: "-1864",
    available_from: "10/26/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/601914",
  },
  {
    ll_id: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    ru_id: "460360",
    verified: "no",
    city: "london",
    neigbourhood: "camden",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "3",
    price: "5647",
    price_vs_Market: "-1213",
    available_from: "10/5/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/460360",
  },
  {
    ll_id: "ddbc053c-262c-4cb5-a444-a0c58389fe35",
    ll_name: "Hello Guest",
    ru_id: "560980",
    verified: "no",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "2000",
    price_vs_Market: "-1040",
    available_from: "11/29/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/560980",
  },
  {
    ll_id: "ddbc053c-262c-4cb5-a444-a0c58389fe35",
    ll_name: "Hello Guest",
    ru_id: "595420",
    verified: "no",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1950",
    price_vs_Market: "-1010",
    available_from: "11/15/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/595420",
  },
  {
    ll_id: "e94b8301-d63d-4e14-97e9-b3c79ef997e1",
    ll_name: "The Square",
    ru_id: "467446",
    verified: "no",
    city: "london",
    neigbourhood: "camden",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "3360",
    price_vs_Market: "-980",
    available_from: "11/18/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/467446",
  },
  {
    ll_id: "b4257a46-2b58-4f5d-830f-97f4eb1114c2",
    ll_name: "Ashleigh Logann",
    ru_id: "378099",
    verified: "yes",
    city: "london",
    neigbourhood: "wandsworth",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "2800",
    price_vs_Market: "-970",
    available_from: "11/16/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/378099",
  },
  {
    ll_id: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    ru_id: "296949",
    verified: "no",
    city: "london",
    neigbourhood: "lambeth",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "2614.25",
    price_vs_Market: "-955.75",
    available_from: "10/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/296949",
  },
  {
    ll_id: "ddbc053c-262c-4cb5-a444-a0c58389fe35",
    ll_name: "Hello Guest",
    ru_id: "466574",
    verified: "no",
    city: "london",
    neigbourhood: "islington",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "2250",
    price_vs_Market: "-940",
    available_from: "10/18/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/466574",
  },
  {
    ll_id: "ddbc053c-262c-4cb5-a444-a0c58389fe35",
    ll_name: "Hello Guest",
    ru_id: "431781",
    verified: "no",
    city: "london",
    neigbourhood: "camden",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "2100",
    price_vs_Market: "-870",
    available_from: "11/22/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/431781",
  },
  {
    ll_id: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    ru_id: "449257",
    verified: "no",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "4047",
    price_vs_Market: "-793",
    available_from: "10/11/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/449257",
  },
  {
    ll_id: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    ru_id: "449254",
    verified: "yes",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "4047",
    price_vs_Market: "-793",
    available_from: "10/10/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/449254",
  },
  {
    ll_id: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    ru_id: "511666",
    verified: "no",
    city: "london",
    neigbourhood: "hackney",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "2215",
    price_vs_Market: "-755",
    available_from: "12/15/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/511666",
  },
  {
    ll_id: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    ru_id: "449251",
    verified: "no",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "4093",
    price_vs_Market: "-747",
    available_from: "10/4/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/449251",
  },
  {
    ll_id: "b46c7353-e56c-4076-8f89-5bb8dacde3fe",
    ll_name: "Your Serviced Space",
    ru_id: "398880",
    verified: "yes",
    city: "london",
    neigbourhood: "wandsworth",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "3000",
    price_vs_Market: "-730",
    available_from: "11/8/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/398880",
  },
  {
    ll_id: "581cbdb4-3620-4cc8-8921-5615b00d4ba4",
    ll_name: "Italian Flat ltd",
    ru_id: "314277",
    verified: "yes",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "2300",
    price_vs_Market: "-700",
    available_from: "12/21/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/london/for-rent:apartments/314277",
  },
  {
    ll_id: "e7417b85-8691-42e5-a5cf-ca1bd7bfdb89",
    ll_name: "GuestReady UK",
    ru_id: "506101",
    verified: "no",
    city: "london",
    neigbourhood: "barnet",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "2327",
    price_vs_Market: "-673",
    available_from: "12/18/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/506101",
  },
  {
    ll_id: "7e4b607d-e94c-4470-bd8c-d96348600ebf",
    ll_name: "Pisoria Ltd",
    ru_id: "561119",
    verified: "no",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "4",
    price: "930",
    price_vs_Market: "-670",
    available_from: "11/5/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/561119",
  },
  {
    ll_id: "a58ee446-380a-4ec8-bddb-e80cb38822f8",
    ll_name: "city View Properties UK Limited",
    ru_id: "516701",
    verified: "yes",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "7",
    price: "660",
    price_vs_Market: "-670",
    available_from: "12/22/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/516701",
  },
  {
    ll_id: "581cbdb4-3620-4cc8-8921-5615b00d4ba4",
    ll_name: "Italian Flat ltd",
    ru_id: "296853",
    verified: "yes",
    city: "london",
    neigbourhood: "hammersmith and fulham",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "1",
    price: "1734",
    price_vs_Market: "-666",
    available_from: "12/26/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/london/for-rent:apartments/296853",
  },
  {
    ll_id: "a58ee446-380a-4ec8-bddb-e80cb38822f8",
    ll_name: "city View Properties UK Limited",
    ru_id: "516700",
    verified: "yes",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "7",
    price: "675",
    price_vs_Market: "-655",
    available_from: "10/10/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/516700",
  },
  {
    ll_id: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    ru_id: "460406",
    verified: "no",
    city: "london",
    neigbourhood: "westminster",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "4208",
    price_vs_Market: "-632",
    available_from: "10/4/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/460406",
  },
  {
    ll_id: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    ru_id: "511633",
    verified: "no",
    city: "london",
    neigbourhood: "camden",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "2688.75",
    price_vs_Market: "-591.25",
    available_from: "12/21/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/511633",
  },
  {
    ll_id: "930d2f88-a2fd-4cc1-822c-0dfff10a5e3e",
    ll_name: "Apartments2Be Unpublished",
    ru_id: "117373",
    verified: "yes",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "3",
    price: "762",
    price_vs_Market: "-568",
    available_from: "11/24/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/london/for-rent:apartments/117373",
  },
  {
    ll_id: "930d2f88-a2fd-4cc1-822c-0dfff10a5e3e",
    ll_name: "Apartments2Be Unpublished",
    ru_id: "122777",
    verified: "yes",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "3",
    price: "762",
    price_vs_Market: "-568",
    available_from: "12/1/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/london/for-rent:apartments/122777",
  },
  {
    ll_id: "57d7cb85-0034-49ba-9c07-007a761a005b",
    ll_name: "StayBeyond",
    ru_id: "460164",
    verified: "yes",
    city: "london",
    neigbourhood: "westminster",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "3",
    price: "5793",
    price_vs_Market: "-567",
    available_from: "12/19/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/460164",
  },
  {
    ll_id: "930d2f88-a2fd-4cc1-822c-0dfff10a5e3e",
    ll_name: "Apartments2Be Unpublished",
    ru_id: "166149",
    verified: "yes",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "4",
    price: "765",
    price_vs_Market: "-565",
    available_from: "10/2/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/london/for-rent:apartments/166149",
  },
  {
    ll_id: "a2de762f-9a1a-41a0-8b6d-1200942b2b5c",
    ll_name: "city Accommodations",
    ru_id: "137758",
    verified: "yes",
    city: "london",
    neigbourhood: "westminster",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "4",
    price: "700",
    price_vs_Market: "-510",
    available_from: "12/2/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/137758",
  },
  {
    ll_id: "930d2f88-a2fd-4cc1-822c-0dfff10a5e3e",
    ll_name: "Apartments2Be Unpublished",
    ru_id: "122547",
    verified: "yes",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "3",
    price: "823",
    price_vs_Market: "-507",
    available_from: "11/7/21",
    admin_fee_type: "notDefined",
    link: "http://www.spotahome.com/london/for-rent:apartments/122547",
  },
  {
    ll_id: "99a912d1-cca8-4250-ad0d-15cebdfd0181",
    ll_name: "Myrooms",
    ru_id: "132463",
    verified: "yes",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "4",
    price: "641",
    price_vs_Market: "-439",
    available_from: "12/22/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/132463",
  },
  {
    ll_id: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    ru_id: "120120",
    verified: "yes",
    city: "london",
    neigbourhood: "hackney",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "6",
    price: "763",
    price_vs_Market: "-427",
    available_from: "10/21/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/120120",
  },
  {
    ll_id: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    ru_id: "120114",
    verified: "yes",
    city: "london",
    neigbourhood: "hackney",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "6",
    price: "763",
    price_vs_Market: "-427",
    available_from: "12/10/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/120114",
  },
  {
    ll_id: "f62011ee-c21e-4a23-a5ed-adea4300982c",
    ll_name: "DC Associated Management LTD",
    ru_id: "120118",
    verified: "yes",
    city: "london",
    neigbourhood: "hackney",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "6",
    price: "763",
    price_vs_Market: "-427",
    available_from: "12/7/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/120118",
  },
  {
    ll_id: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    ru_id: "225996",
    verified: "yes",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "4415",
    price_vs_Market: "-425",
    available_from: "10/25/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/225996",
  },
  {
    ll_id: "0cbedaf7-c641-4e3f-90f8-ca28d7b0f130",
    ll_name: "Sak Vis",
    ru_id: "475955",
    verified: "yes",
    city: "london",
    neigbourhood: "tower hamlets",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "2",
    price: "2650",
    price_vs_Market: "-410",
    available_from: "10/8/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/475955",
  },
  {
    ll_id: "831383f9-f15d-421f-b404-c45372fd0707",
    ll_name: "Let Club ltd",
    ru_id: "380955",
    verified: "yes",
    city: "london",
    neigbourhood: "kensington and chelsea",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "2941.666667",
    price_vs_Market: "-388.3333333",
    available_from: "10/31/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/380955",
  },
  {
    ll_id: "72ff8d0c-7dc5-4e22-9eb3-a697013717d8",
    ll_name: "HOUST",
    ru_id: "510977",
    verified: "no",
    city: "london",
    neigbourhood: "hammersmith and fulham",
    ll_engagement: "low",
    property_type: "studio",
    rooms: "0",
    price: "1997.166667",
    price_vs_Market: "-342.8333333",
    available_from: "11/8/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/london/for-rent:apartments/510977",
  },
];
